/** Full-screen status while the session or user row is being established. */
import { Terminal, AlertTriangle } from "lucide-react";
import { cn } from "@/lib/utils";

export function BootSplash({
  message,
  detail,
  tone = "neutral",
}: {
  message: string;
  detail?: string;
  tone?: "neutral" | "error";
}) {
  const isError = tone === "error";

  return (
    <div
      className="min-h-screen flex items-center justify-center p-6"
      style={{
        paddingTop: "calc(1.5rem + env(safe-area-inset-top, 0px))",
        paddingBottom: "calc(1.5rem + env(safe-area-inset-bottom, 0px))",
      }}
    >
      <div className="text-center space-y-4 max-w-md">
        <div className="flex justify-center">
          <div
            className={cn(
              "w-16 h-16 rounded-2xl flex items-center justify-center",
              isError
                ? "bg-destructive/10 border border-destructive/30"
                : "brand-tile glow-effect",
            )}
          >
            {isError ? (
              <AlertTriangle className="w-8 h-8 text-destructive" />
            ) : (
              <Terminal className="w-8 h-8" />
            )}
          </div>
        </div>

        <p
          className={cn(
            "text-sm",
            isError ? "text-destructive font-medium" : "text-muted-foreground",
          )}
        >
          {message}
          {!isError && <span className="animate-pulse-ring">…</span>}
        </p>

        {detail && (
          <p className="text-xs text-muted-foreground leading-relaxed">{detail}</p>
        )}
      </div>
    </div>
  );
}
